export default {
  common: {
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    getStarted: 'Get Started',
  },
  nav: {
    home: 'Home',
    features: 'Features',
    pricing: 'Solutions',
    contact: 'Contact Us',
    login: 'Login',
    signup: 'Sign Up',
  },
  hero: {
    title: 'YouCRM - Customized CRM Solutions',
    subtitle: 'Tailor-made CRM solutions to meet your unique business needs',
    description: 'Are you tired of expensive and unusable custom developments? Do programmers keep making promises for months? Still can\'t access your daily tasks on mobile?',
    cta: 'Request a Demo',
  },
  features: {
    title: 'Key Features',
    customerManagement: {
      title: 'Customer Management',
      description: 'Easily manage your customer database and keep track of all interactions',
    },
    salesAutomation: {
      title: 'Sales Automation',
      description: 'Automate your sales process and close deals faster',
    },
    reporting: {
      title: 'Advanced Reporting',
      description: 'Get insights into your business with powerful reporting tools',
    },
    mobileFriendly: {
      title: 'Mobile Friendly',
      description: 'Access your CRM from anywhere, on any device',
    },
  },
  pricing: {
    title: 'Our Solutions',
    subtitle: 'Customized for your business',
    basic: {
      name: 'Small Business',
      price: 'Custom',
      period: 'pricing',
      description: 'Perfect for small businesses with basic CRM needs',
      features: [
        'Customer database management',
        'Basic reporting',
        'Email support',
        'Mobile access',
      ],
    },
    pro: {
      name: 'Business',
      price: 'Custom',
      period: 'pricing',
      description: 'For growing businesses with advanced needs',
      features: [
        'Unlimited customers',
        'Advanced reporting',
        'Priority support',
        'API access',
      ],
    },
    enterprise: {
      name: 'Enterprise',
      price: 'Custom',
      period: 'pricing',
      description: 'For large organizations with complex requirements',
      features: [
        'Fully customized solution',
        'Custom reporting',
        '24/7 support',
        'Dedicated account manager',
      ],
    },
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Request a demo or get in touch with our team',
    name: 'Name',
    email: 'Email',
    message: 'Message',
    send: 'Send Message',
    success: 'Your message has been sent. We\'ll get back to you shortly!',
    error: 'There was an error sending your message. Please try again.',
  },
  footer: {
    rights: 'All rights reserved',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
  },
}; 